import { isElement } from 'libraries/lodash'
import { getParentElement } from 'front-end-core/helpers/document'

export const getNode = condition => {
  const inner = node => {
    if (!node || !isElement(node)) {
      return false
    }
    if (condition(node)) {
      return node
    }
    return inner(getParentElement(node))
  }
  return inner
}

export const isLink = getNode(node => node.tagName === 'A')
